var render = function () {
  var _vm$user, _vm$user2, _vm$user3;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "shadow-sm rounded-lg p-4"
  }, [_c('h4', {
    staticClass: "font-bold text-xl leading-7 mb-4 block"
  }, [_vm._v("Accounts Details")]), _c('div', {
    staticClass: "grid grid-cols-2 gap-2"
  }, [_c('div', [_c('div', {
    staticClass: "flex-col"
  }, [_c('label', {
    staticClass: "block text-sm font-semibold text-gray-900 gd-dt"
  }, [_vm._v(" Account ID ")]), _c('p', {
    staticClass: "mb-2 text-gray-500"
  }, [_vm._v(" " + _vm._s(_vm.user ? _vm.user.id : '') + " ")])]), _c('div', [_c('label', {
    staticClass: "block text-sm font-semibold text-gray-900 gd-dt"
  }, [_vm._v(" Account Email ")]), _c('p', {
    staticClass: "text-gray-500"
  }, [_vm._v(" " + _vm._s(this.$route.params.id) + " ")])]), _c('div', {
    staticClass: "flex justify-between items-center w-1/2"
  }, [_c('div', [_c('label', {
    staticClass: "block text-sm font-semibold text-gray-900 gd-dt"
  }, [_vm._v(" First Name ")]), _c('p', {
    staticClass: "text-gray-500"
  }, [_vm._v(" " + _vm._s(((_vm$user = _vm.user) === null || _vm$user === void 0 ? void 0 : _vm$user.first_name) || ' - ') + " ")])]), _c('div', [_c('label', {
    staticClass: "block text-sm font-semibold text-gray-900 gd-dt"
  }, [_vm._v(" Last Name ")]), _c('p', {
    staticClass: "text-gray-500"
  }, [_vm._v(" " + _vm._s(((_vm$user2 = _vm.user) === null || _vm$user2 === void 0 ? void 0 : _vm$user2.last_name) || ' - ') + " ")])])])]), _c('div', [_c('div', [_c('label', {
    staticClass: "block text-sm font-semibold text-gray-900 gd-dt"
  }, [_vm._v(" Status ")]), _vm.user.is_active ? _c('span', {
    staticClass: "bg-green-100 mb-2 text-green-800 px-2 py-1 rounded-lg"
  }, [_vm._v(" Active ")]) : _c('span', {
    staticClass: "bg-gray-100 text-gray-800 px-2 mb-2 py-1.5"
  }, [_vm._v(" In Active ")])]), _c('div', [_c('label', {
    staticClass: "block text-sm font-semibold text-gray-900 gd-dt mt-2"
  }, [_vm._v(" Joined date ")]), _c('p', {
    staticClass: "text-gray-500"
  }, [_vm._v(" " + _vm._s(_vm.formatDateBasic((_vm$user3 = _vm.user) === null || _vm$user3 === void 0 ? void 0 : _vm$user3.created) || ' - ') + " ")])]), _c('div', [_c('label', {
    staticClass: "block text-sm font-semibold text-gray-900 gd-dt"
  }, [_vm._v(" Last Log in ")]), _c('p', {
    staticClass: "text-gray-500"
  }, [_vm._v(" " + _vm._s(_vm.formatDate(_vm.user.last_login) || '-') + " ")])]), _c('div', {
    staticClass: "mt-2"
  }, [_c('label', {
    staticClass: "block text-sm font-semibold text-gray-900 gd-dt"
  }, [_vm._v(" Banned ")]), _c('label', {
    staticClass: "switch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.UserBanned.is_active,
      expression: "UserBanned.is_active"
    }],
    class: {
      isBannedToggle: _vm.UserBanned.is_active
    },
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.UserBanned.is_active) ? _vm._i(_vm.UserBanned.is_active, null) > -1 : _vm.UserBanned.is_active
    },
    on: {
      "change": [function ($event) {
        var $$a = _vm.UserBanned.is_active,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && _vm.$set(_vm.UserBanned, "is_active", $$a.concat([$$v]));
          } else {
            $$i > -1 && _vm.$set(_vm.UserBanned, "is_active", $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.$set(_vm.UserBanned, "is_active", $$c);
        }
      }, function ($event) {
        return _vm.actionBoolean(_vm.UserBanned.is_active);
      }]
    }
  }), _c('span', {
    staticClass: "slider-banned"
  })]), _c('t-modal', {
    ref: "bannedModal",
    on: {
      "before-close": _vm.onBeforeClose
    }
  }, [_c('div', {
    staticClass: "text-sm flex-col text-center items-center"
  }, [_c('label', {
    staticClass: "text-center font-semibold text-lg leading-relaxed"
  }, [_vm._v(" " + _vm._s(((_vm.UserBanned.is_active === true ? 'Are you sure you want to ban this account?' : 'Are you sure you want to unban this account?') + " ")) + " ")]), _c('p', {
    staticClass: "text-center text-gray-500 text-base leading-relaxed"
  }, [_vm._v(" " + _vm._s(("" + (_vm.UserBanned.is_active === true ? "Once you save this data and ban this account, then the user will not be able to use this account." : 'Once you save this data and unban this account, then the user will be able to use this account again.'))) + " ")])]), _c('div', {
    staticClass: "flex justify-center"
  }, [_c('button', {
    staticClass: "bg-blue-700 text-white border p-1 px-2 rounded-lg text-sm",
    on: {
      "click": function ($event) {
        return _vm.handleBannded();
      }
    }
  }, [_vm._v(" Save ")]), _c('button', {
    staticClass: "text-gray-500 border p-1 px-2 rounded-lg mr-1 ml-2 text-sm",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(" Cancel ")])])])], 1)])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }